module.exports = __webpack_public_path__ + "static/media/136-eye.036b4306.svg";